import "./SelectCollectionEntryDlg.scss";


export const SelectCollectionEntryDlg = (props) => {

    return <div>todo</div>;
}